// @ts-nocheck
// Theme.store.language is the active page's locale (e.g. "EN", "DE") - used
// instead of a hardcoded locale so delivery-date text actually follows the
// site's language instead of always rendering in English.
const dateLocale = (Theme.store.language || 'en').toLowerCase();

// Abbreviated weekday + 2-digit day + abbreviated month (e.g. "Thu 01 Oct"),
// with weekday and month translated to the active locale's native short
// form (lengths genuinely vary - German weekdays are correctly 2 letters,
// "Mo"/"Di", not 3). Built field-by-field rather than via one combined
// Intl.DateTimeFormat call, because the combined form's field ORDER is
// locale-dependent too, not just the words - plain "en" (unlike "en-GB")
// defaults to US-style "Oct 19" rather than "19 Oct", which would silently
// reorder the string per-locale instead of just translating it. Trailing
// periods/commas some locales add (e.g. French "lun.", "oct.") are
// stripped so the separator is always a plain space.
function formatDeliveryDate(date) {
  const strip = (s) => s.replace(/[.,]$/, '');
  const weekday = strip(new Intl.DateTimeFormat(dateLocale, { weekday: 'short' }).format(date));
  const day = String(date.getDate()).padStart(2, '0');
  const month = strip(new Intl.DateTimeFormat(dateLocale, { month: 'short' }).format(date));
  return `${weekday} ${day} ${month}`;
}

if (!customElements.get('stock-indicator')) {
    customElements.define(
      'stock-indicator',
      class StockIndicator extends HTMLElement {
        constructor() {
          super();

          this.container = this;
          this.expectedStart = parseInt(this.getAttribute('data-expected-start'), 10);
          this.expectedEnd = parseInt(this.getAttribute('data-expected-end'), 10);
          this.expectedTxtContainer = this.querySelector('.expected-delivery-dates');
          this.isInStock = this.getAttribute('data-is-in-stock');
          this.backInStockStart = this.getAttribute('data-back-in-stock-start');
          this.backInStockEnd = this.getAttribute('data-back-in-stock-end');
          this.continueSelling = this.getAttribute('data-continue-selling');
          this.secondaryFormat = this.getAttribute('data-secondary-format');

          this.backInStockOffsetWeeksStart = this.getAttribute('data-back-in-stock-offset-start');
          this.backInStockOffsetWeeksEnd = this.getAttribute('data-back-in-stock-offset-end');
        }

        getDatesFromWeeks() {
          const addCalendarWeeksSkippingWeekends = (startDate, weeks) => {
            let result = new Date(startDate);
            let daysAdded = 0;
            const totalDays = weeks * 7;

            while (daysAdded < totalDays) {
              result.setDate(result.getDate() + 1);
              const day = result.getDay();
              if (day !== 0 && day !== 6) {
                daysAdded++;
              }
            }

            return result;
          };

          const today = new Date();
          const weeksStart = parseInt(this.backInStockOffsetWeeksStart, 10);
          const weeksEnd = parseInt(this.backInStockOffsetWeeksEnd, 10);

          const startDate = addCalendarWeeksSkippingWeekends(today, weeksStart);
          const endDate = addCalendarWeeksSkippingWeekends(today, weeksEnd);

          return {
            start: startDate.toISOString().split('T')[0],
            end: endDate.toISOString().split('T')[0],
            formattedStart: formatDeliveryDate(startDate),
            formattedEnd: formatDeliveryDate(endDate),
          };
        }

        connectedCallback() {
          if (!this.expectedTxtContainer) return;

          const isTodayOrAfter = (dateString) => {
            const inputDate = new Date(dateString);
            const today = new Date();
            inputDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
            return today >= inputDate;
          };

          const formatDate = (dateString) => formatDeliveryDate(new Date(dateString));

          if (this.isInStock == "false" && this.continueSelling == "false") {
            this.container.style.display = "flex";
            return;
          }

          if (this.isInStock == "false" && this.backInStockStart && this.backInStockEnd) {
            if (isTodayOrAfter(this.backInStockStart)) {
              this.calculateDeliveryDates();
              this.container.style.display = "flex";
            } else {
              const formattedBackInStockStart = formatDate(this.backInStockStart);
              const formattedBackInStockEnd = formatDate(this.backInStockEnd);
              this.expectedTxtContainer.textContent = `${formattedBackInStockStart} - ${formattedBackInStockEnd}`;
              this.container.style.display = "flex";
            }
          }
          else if (this.isInStock == "false" && this.backInStockOffsetWeeksStart && this.backInStockOffsetWeeksEnd) {
            const { start, formattedStart, formattedEnd } = this.getDatesFromWeeks();

            if (isTodayOrAfter(start)) {
              this.calculateDeliveryDates();
            } else {
              this.expectedTxtContainer.textContent = `${formattedStart} - ${formattedEnd}`;
            }

            this.container.style.display = "flex";
          }
          else if(this.isInStock == "true") {
            this.calculateDeliveryDates();
            this.container.style.display = "flex";
          }
        }

        calculateDeliveryDates(start = this.expectedStart, end = this.expectedEnd) {
          const addWeekdays = (startDate, daysToAdd) => {
            let result = new Date(startDate);
            let addedDays = 0;

            while (addedDays < daysToAdd) {
              result.setDate(result.getDate() + 1);
              const day = result.getDay();
              if (day !== 0 && day !== 6) {
                addedDays++;
              }
            }

            return result;
          };

          const today = new Date();
          const startDate = addWeekdays(today, start);
          const endDate = addWeekdays(today, end);

          this.expectedTxtContainer.textContent = `${formatDeliveryDate(startDate)} - ${formatDeliveryDate(endDate)}`;
        }
      }
    );
}